import { DigitalBudgetTableRowData } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';

enum PriorityType {
  MustHave = 'Must Have',
  Optional = 'Optional',
  TechCost = 'Est. Tech Cost',
}

interface PriorityGroup {
  impressions: number;
  clicks: number;
  videoViews: number;
  budget: { value: number; currency: string };
  reach: number;
}

const calculateDigitalTotalBudgetRowData = (
  rows: DigitalBudgetTableRowData[]
): DigitalBudgetTableRowData => {
  const defaultCurrency = 'PLN';

  const priorityGroups: Record<PriorityType, PriorityGroup> = {
    [PriorityType.MustHave]: {
      impressions: 0,
      clicks: 0,
      videoViews: 0,
      budget: { value: 0, currency: defaultCurrency },
      reach: 0,
    },
    [PriorityType.Optional]: {
      impressions: 0,
      clicks: 0,
      videoViews: 0,
      budget: { value: 0, currency: defaultCurrency },
      reach: 0,
    },
    [PriorityType.TechCost]: {
      impressions: 0,
      clicks: 0,
      videoViews: 0,
      budget: { value: 0, currency: defaultCurrency },
      reach: 0,
    },
  };

  rows.forEach((row) => {
    row.children?.forEach((child) => {
      const group = child.isMandatory
        ? PriorityType.MustHave
        : PriorityType.Optional;
      priorityGroups[group].impressions += child.impressions || 0;
      priorityGroups[group].clicks += child.clicks || 0;
      priorityGroups[group].videoViews += child.videoViews || 0;
      priorityGroups[group].budget.value += child.budget.value;
      priorityGroups[group].reach += child.reach || 0;
      priorityGroups[group].budget.currency = child.budget.currency;
    });

    if (row.techCost) {
      priorityGroups[PriorityType.TechCost].budget.value +=
        (row.techCost.dsp || 0) + (row.techCost.adServer || 0);
      priorityGroups[PriorityType.TechCost].budget.currency =
        row.budget.currency;
    }
  });

  const totalBudget = rows.reduce(
    (sum, row) => {
      const techCostValue = row.techCost
        ? (row.techCost.dsp || 0) + (row.techCost.adServer || 0)
        : 0;

      return {
        value: sum.value + row.budget.value + techCostValue,
        currency: row.budget.currency,
      };
    },
    { value: 0, currency: defaultCurrency }
  );

  return {
    touchpointName: 'mediaPlanning.totalDigital',
    impressions: rows.reduce((sum, row) => sum + (row.impressions || 0), 0),
    reach: rows.reduce((sum, row) => sum + (row.reach || 0), 0),
    clicks: rows.reduce((sum, row) => sum + (row.clicks || 0), 0),
    videoViews: rows.reduce((sum, row) => sum + (row.videoViews || 0), 0),
    budget: totalBudget,
    oneReach:
      rows.reduce((sum, row) => sum + (row.oneReach || 0), 0) / rows.length,
    children: Object.entries(priorityGroups).map(([type, metrics]) => ({
      type,
      touchpointFunnel: type,
      isMandatory: type === PriorityType.MustHave,
      impressions: metrics.impressions,
      reach: metrics.reach,
      clicks: metrics.clicks,
      videoViews: metrics.videoViews,
      budget: metrics.budget,
    })),
  };
};

export default calculateDigitalTotalBudgetRowData;
